import { useRouter } from "next/navigation";
import LandingSubText from "../ui/landing-sub-text";
import Link from "next/link";
import { useState } from "react";
import DynamicIcon from "../ui/dynamic-icon";
import LandingPageHeader from "../ui/landing-page-header";
import { prefix } from "../../lib/auth";
import LandingHeroText from "../ui/landing-hero-text";
import LandingPrimaryText from "../ui/landing-primary-text";
import LandingPrimaryButton from "../ui/landing-primary-button";
import Image from "next/image";
import { useTranslations } from 'next-intl';

const LandingHero = () => {
    const router = useRouter();
    const [showBlog, setShowBlog] = useState(true);
    const t = useTranslations('landing');

    return (
        <>
            <div className='w-full h-fit bg-[url("/images/landing-hero-bg.png")] bg-grey-900 bg-no-repeat bg-cover bg-center'>
                <LandingPageHeader />
                <div className="max-w-[90%] lg:max-w-[1137px] m-auto grid gap-[143px] lg:gap-[84px] justify-items-center pt-[171px] lg:pb-[109px]">
                    <div className="grid gap-[40px]">
                        <div className="grid gap-[24px]">
                            <LandingHeroText>{t('heroTitle')}<br />{t('heroTitleLine2')}</LandingHeroText>
                            <LandingPrimaryText>{t('heroSubtitle')} <br /><span className="lg:block hidden">{t('heroSubtitleLine2')}</span></LandingPrimaryText>
                        </div>
                        <LandingPrimaryButton onClick={() => router.push(`http://${prefix()}accounts.workpeg.com/register?peg=email`)}>{t('signUp')}</LandingPrimaryButton>
                    </div>
                    <div className='grid md:max-w-[90%] lg:max-w-[100%] max-w-[80%] w-full m-auto'>
                        <Image alt='email' src='/images/email-demo.png' width={1073} height={670} className='m-auto' />
                        {/* <Image alt='email' src='/images/email-demo-dark.png' width={1073} height={670} className=' dark:block hidden m-auto' /> */}
                    </div>
                </div>
            </div>
        </>

        //  <div className="w-[298px] lg:w-[370px] h-[54px] lg:h-[57px] rounded-[50px] border-[3px] border-white-400 px-[12px] flex gap-[12px] items-center justify-start">
        //                 <div className="px-[20px] h-[34px] lg:h-[37px] grid items-center justify-center bg-grey-900 rounded-[60px]"><DemoSecondaryText additionalclasses='!text-white-50'>New</DemoSecondaryText></div>
        //                 <DemoPrimaryText additionalclasses='!text-[12px] lg:!text-[16px]'>We&apos;ve released a new peg</DemoPrimaryText>
        //             </div>
        //             <div className="grid gap-[24px]">
        //                 <p className="poppins-bold text-[28px] lg:text-[60px] lg:leading-[72px] text-center text-grey-900">Streamline Your Workspace, One Email at a Time</p>
        //                 <DemoPrimaryText additionalclasses='max-w-[680px] m-auto !text-center !text-grey-400'>Effortlessly manage tasks, collaborate with your team, and stay organized—all from your inbox. Workpeg Email simplifies your workflow, so you can focus on what matters most.</DemoPrimaryText>
        //             </div>
        //             <div className="grid lg:flex gap-[18px] justify-center items-center mb-[45px] lg:mb-[40px]">
        //                 <DemoPrimaryButton onClick={() => router.push(`http://${prefix()}accounts.workpeg.com/register?peg=email`)} additionalclasses='!w-[235px] lg:!w-fit'>Become an early user</DemoPrimaryButton>
        //             </div>
    );
};

export default LandingHero;